import * as React from 'react';
import { SidePanelContainer } from '../common/sidePanel';
import { NavbarContainer } from '../navbar';
import { TimelineContainer } from '../timeline';

const App: React.SFC = () => (
  <SidePanelContainer>
    <div className="ap">
      <NavbarContainer />
      <TimelineContainer />
    </div>
  </SidePanelContainer>
);

export default App;



// WEBPACK FOOTER //
// ./src/components/app/App.tsx